import { BrowserModule } from "@angular/platform-browser";
import { NgModule, ErrorHandler } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import CBAErrorHandler from "./error/error.handler";
import { ProductsComponent } from "./products/products.component";
import { ExportProductsComponent } from "./products/export_products.component";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./login/logout.component";
import { HomeComponent } from "./home/home.component";
import { ErrorComponent } from "./error/error.component";
import { NoteComponent } from "./note/note.component";
import { SearchComponent } from "./search/search.component";

import { UnderscorecasePipe } from "./custom/underscorecase.pipe";
import { CustomDatePipe } from "./custom/date.pipe";
import { AutofocusDirective } from "./custom/autofocus.directive";
// import { Heap } from "./heap";
import { environment } from "../environments/environment";
import { enableProdMode } from "@angular/core";
import { SalesPresentersComponent } from "./products/sales-presenters/sales-presenters.component";
import { ProductDetailComponent } from "./products/product-detail/product-detail.component";
import { AllProductsComponent } from "./products/all-products/all-products.component";
import { ProductSummaryComponent } from "./products/product-summary/product-summary.component";
import { CookieService } from "ngx-cookie-service";

if (environment["env"] != "development") {
  enableProdMode();
}
// if (environment.heap && environment.heap.enabled) {
//   Heap.load(environment.heap.appid);
// }

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    HomeComponent,
    ProductsComponent,
    ExportProductsComponent,
    ErrorComponent,
    NoteComponent,
    SearchComponent,
    UnderscorecasePipe,
    CustomDatePipe,
    AutofocusDirective,
    SalesPresentersComponent,
    ProductDetailComponent,
    AllProductsComponent,
    ProductSummaryComponent
  ],
  imports: [BrowserModule, FormsModule, HttpModule, AppRoutingModule],
  providers: [
    { provide: ErrorHandler, useClass: CBAErrorHandler },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts